<template>
	<div
		:class="`formulate-input-element formulate-input-element--${context.class}`"
		:data-type="context.type"
	>
		<div class="description">
			<ul>
				<li
					v-for="item in itemsQuery"
					:key="item.split(separator)[1]"
					class="d-flex flex-row align-items-center"
				>
					<div>
						{{ item.split(separator)[0] }}
					</div>
					<a
						role="button"
						class="ml-2 text-decoration-none"
						style="cursor: pointer;"
						@click="deleteQuery(item)"
					>
						(удалить)
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>

export default {
	props: {
		context: {
			type: Object,
			required: true,
		},
	},
	computed: {
		queryName() {
			return this.context.attributes.queryName;
		},
		separator() {
			return this.context.attributes.separator;
		},
		itemsQuery() {
			return this.$route.query[this.queryName] ?? [];
		},
	},
	watch: {
		itemsQuery: {
			handler(array) {
				this.context.model = array.map((el) => el.split(this.separator)[1]);
			},
		},
	},
	methods: {
		deleteQuery(item) {
			const array = this.$route.query[this.queryName].filter((el) => el !== item);
			if (array.length > 0) {
				this.$router.push({
					query: {
						...this.$route.query,
						[this.queryName]: array,
					},
				});
			} else {
				this.$router.replace({ [this.queryName]: null });
			}
		},
	},
};
</script>

<style scoped lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";
</style>
